import { ReactElement, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link, NavLink, useLocation, useNavigate, Route } from 'react-router-dom';
import logo_headerpc_main from '../../assets/img/logo_headerpc_main.png';
import logo_headerpc_otherpage from '../../assets/img/logo_headerpc_otherpage.png';
import logo_headermb from '../../assets/img/logo_headermb.png';
import logo_headermb_otherpage from '../../assets/img/logo_headermb_otherpage.png';
import prev1 from '../../assets/img/prev1.png';
import prev2 from '../../assets/img/prev2.png';
import i18n from '../../i18n';
import button_triangle_icon from '../../assets/img/button-triangle-icon.svg';
const scrollHandler = () => {
  const nav = document.querySelector('.nav-bar');
  nav?.classList.toggle('bg-blue', window.scrollY > 500);
};
function Preview(): ReactElement {
  const custom_navbar = location.pathname === '/' ? 'white' : '#113577';

  const pcView =
    <>
      {/* pc view start */}
      {/* header start */}
      <div className={`header`}>
        <img src={logo_headermb_otherpage} alt="Logo Colligence" />
      </div>
      {/* header end */}
      <div className={`preview-container`}>
        <div className={`title`}>
          <div className={`title-text`}>Empowering <br /> Web3 and Healthcare Innovation</div>
        </div>
        <div className={'content-box'} >
          <div className={'content1'} onClick={() => window.location.href = 'https://talken.io'}>
            <div className={'desc-box'}>
              <div className={'title'}>Talken</div>
              <div className={'text'}>Secure Web3 Wallet with MPC technology.</div>
              <div className={'text'}>Accessible on Mobile, Web, Telegram, and Desktop.</div>
              <button className={'button'} onClick={() => window.location.href = 'https://talken.io'}>
                More
                <img src={button_triangle_icon} alt="button" />
              </button>
            </div>
          </div>
          <div className={'content2'}
            // onClick={() => window.location.href = 'https://medi7.io'}
          >
            <div className={'desc-box'}>
              <div className={'title'}>Medi7</div>
              <div className={'text'}>Remote consults before arrival, premium care in Korea.</div>
              <div className={'text'}>A global remote healthcare platform for international patients.</div>
              <button className={'button'}
                disabled
                // onClick={() => window.location.href = 'https://medi7.io'}
              >
                Coming soon
                {/* <img src={button_triangle_icon} alt="button" /> */}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* footer start */}
      {/* <div className={'preview-footer-container'}> */}
        <div className={'preview-footer'}>
          <div className={'text'}>© 2025 Colligence Inc. All Rights Reserved.</div>
        </div>
      {/* </div> */}
      {/* footer end */}
      {/* pc view end */}
    </>;
  const mobileView =
    <>
      <div className={`header`}>
        <div className='header-container'>
          <img src={logo_headermb_otherpage} alt="Logo Colligence" />
          <div className='text'>EN</div>
        </div>
      </div>
      <div className={`preview-container`}>
        <div className={`title`}>
          <div className={`title-text`}>Empowering <br /> Web3 and Healthcare Innovation</div>
        </div>
        <div className={'content-box-mb'} >
          <div className={'content1-mb'} onClick={() => window.location.href = 'https://talken.io'}>
            <div className={'desc-box'}>
              <div className={'title'}>Talken</div>
              <div className={'text'}>Secure Web3 Wallet with MPC technology.</div>
              <div className={'text'}>Accessible on Mobile, Web, Telegram, and Desktop.</div>
              <button className={'button'} onClick={() => window.location.href = 'https://talken.io'}>
                More
                <img src={button_triangle_icon} alt="button" />
              </button>
            </div>
          </div>
          <div className={'content2-mb'}
          // onClick={() => window.location.href = 'https://medi7.io'}
          >
            <div className={'desc-box'}>
              <div className={'title'}>Medi7</div>
              <div className={'text'}>Remote consults before arrival, premium care in Korea. A global remote healthcare platform for international patients.</div>
              <button className={'button'}
                disabled
              // onClick={() => window.location.href = 'https://medi7.io'}
              >
                Coming soon
                {/* <img src={button_triangle_icon} alt="button" /> */}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* footer start */}
        <div className={'preview-footer'}>
          <div className={'text'}>© 2025 Colligence Inc. All Rights Reserved.</div>
        </div>
      {/* footer end */}
    </>
  return (
    <div className={'preview-page'}>
      <div className={'hidden-mobile'}>{pcView}</div>
      <div className={'hidden-pc'}>{mobileView}</div>
    </div>
  );
}

export default Preview;